import React from "react";
import classNames from "classnames";
import PropTypes from "prop-types";
import Save from "rialto-icons/Apply";
import Delete from "rialto-icons/Delete";
import Edit from "rialto-icons/Edit";
import Cancel from "rialto-icons/Reset";

import Translate from "utils/translate";

import styles from "./FormButton.css";

const { t } = new Translate("FormButton");

const IconType = {
  save: Save,
  cancel: Cancel,
  edit: Edit,
  delete: Delete,
};

const FormButton = ({ active, isLarge, label, onClick, type, withIcon }) => {
  const Icon = IconType[type];

  return (
    <button
      className={classNames(styles.root, styles[type], {
        [styles.active]: active,
        [styles.large]: isLarge,
        [styles.icon]: withIcon,
      })}
      onClick={() => (onClick ? onClick() : null)}
      type={!onClick && type === "save" ? "submit" : "button"}
    >
      {withIcon ? <Icon size={isLarge ? "" : "small"} /> : label || t(type)}
    </button>
  );
};

FormButton.propTypes = {
  label: PropTypes.string,
  type: PropTypes.oneOf(["cancel", "edit", "save", "delete"]).isRequired,
  onClick: PropTypes.func,
  active: PropTypes.bool,
  isLarge: PropTypes.bool,
  withIcon: PropTypes.bool,
};

export default FormButton;
